export default __webpack_public_path__ + "5794f371b03fdacbf839da9aee0baddd.png";